import Error404Page from './Error404Page';

const Page404Config = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  routes: [
    {
      path: '404',
      element: <Error404Page />,
      auth: null,
    },
  ],
};

export default Page404Config;
